import { Chip, styled, Table, Typography } from '@mui/joy';
import { css } from '@mui/system';

import { I18N_DE } from '@/i18n/de';
import { SignGroup } from '@/modules/api';

type SignGroupDetailsProps = { signGroup: SignGroup };

const StyledTable = styled(Table)(
  () => css`
    padding: 0px 16px;

    & tbody > tr > td:first-child {
      width: 150px;
    }

    & tbody > tr > td:first-child,
    tbody > tr > td:last-child {
      border: none;
      padding: 4px;
      min-height: 24px;
      vertical-align: sub;
    }

    p {
      font-weight: 400;
      white-space: pre-line;
    }
  `,
);

const KeyTypography = styled(Typography)(
  ({ theme }) => css`
    color: ${theme.palette.text.tertiary};
    font-size: 14px;
  `,
);

const ValueTypography = styled(Typography)(
  ({ theme }) => css`
    color: ${theme.palette.neutral.plainColor};
    font-size: 16px;
  `,
);

const getConfideceColor = (confidence: number) => {
  if (confidence >= 90) return 'success';
  if (confidence >= 70) return 'warning';

  return 'danger';
};

export function SignGroupDetails({ signGroup }: SignGroupDetailsProps) {
  return (
    <StyledTable>
      <tbody>
        <tr>
          <td>
            <KeyTypography>Ausrichtung</KeyTypography>
          </td>
          <td>
            <ValueTypography>{Number.isInteger(signGroup.bearing) && `${signGroup.bearing}°`}</ValueTypography>
          </td>
        </tr>
        <tr>
          <td>
            <KeyTypography>Abstand zum Fahrbahnrand</KeyTypography>
          </td>
          <td>
            <ValueTypography>
              {signGroup.roadsideDistance || signGroup.roadsideDistance === 0
                ? `${(signGroup.roadsideDistance / 100).toFixed(2)} m`
                : ''}
            </ValueTypography>
          </td>
        </tr>
        <tr>
          <td>
            <KeyTypography>Aufstellseite</KeyTypography>
          </td>
          <td>
            <ValueTypography>
              {signGroup.installationSide ? I18N_DE.SignGroupInstallationSide[signGroup.installationSide] : ''}
            </ValueTypography>
          </td>
        </tr>
        <tr>
          <td>
            <KeyTypography>Straßen-Kennung (SIB ID)</KeyTypography>
          </td>
          <td>
            <ValueTypography>{signGroup.sibId || ''}</ValueTypography>
          </td>
        </tr>
        <tr>
          <td>
            <KeyTypography>Art der Gruppe</KeyTypography>
          </td>
          <td>
            <ValueTypography>{I18N_DE.SignGroupType[signGroup.type]}</ValueTypography>
          </td>
        </tr>
        <tr>
          <td>
            <KeyTypography>OpenLR Referenzierung</KeyTypography>
          </td>
          <td>
            <ValueTypography>{signGroup.openLRBinary}</ValueTypography>
          </td>
        </tr>
        <tr>
          <td>
            <KeyTypography>OpenLR Konfidenz</KeyTypography>
          </td>
          <td>
            {signGroup.openLRConfidence ? (
              <Chip color={getConfideceColor(signGroup.openLRConfidence)}>{signGroup.openLRConfidence} %</Chip>
            ) : null}
          </td>
        </tr>
      </tbody>
    </StyledTable>
  );
}
